import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

const STORAGE_KEY = 'edpad_teacher_cookie_consent'

/**
 * Уведомление о cookies, требуемое 152-ФЗ + рекомендациями Роскомнадзора.
 * Сохраняет выбор в localStorage, чтобы больше не показывать.
 */
export function CookieBanner() {
  const { t } = useTranslation()
  const [show, setShow] = useState(false)
  const [analytics, setAnalytics] = useState(true)

  useEffect(() => {
    if (!localStorage.getItem(STORAGE_KEY)) setShow(true)
  }, [])

  const save = (allow: boolean) => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ analytics: allow, ts: Date.now() }))
    setShow(false)
  }

  if (!show) return null

  return (
    <div className="fixed bottom-3 inset-x-3 md:bottom-0 md:inset-x-0 z-50 rounded-xl md:rounded-none bg-[#0f0a1c]/95 backdrop-blur border border-white/10 md:border-t md:border-x-0 md:border-b-0 shadow-[0_-4px_24px_rgba(0,0,0,0.35)] animate-fade-up">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-3 md:py-5 flex flex-col md:flex-row gap-3 md:gap-6 items-start md:items-center">
        <div className="flex-1 min-w-0">
          <div className="font-semibold text-gray-100 text-sm md:text-base flex items-center gap-2">
            🍪 {t('cookieBanner.title')}
          </div>
          <div className="text-xs md:text-sm text-gray-400 leading-relaxed mt-1 hidden sm:block">
            {t('cookieBanner.descPrefix')}{' '}
            <Link to="/privacy" className="text-purple-300 underline hover:text-purple-200">
              {t('cookieBanner.privacyLink')}
            </Link>
            .
          </div>
          <div className="text-xs text-gray-400 mt-1 sm:hidden">
            {t('cookieBanner.descMobile')}{' '}
            <Link to="/privacy" className="text-purple-300 underline">
              {t('cookieBanner.moreLink')}
            </Link>
          </div>
          <label className="hidden md:inline-flex items-center gap-2 mt-3 text-sm text-gray-300 cursor-pointer select-none">
            <input
              type="checkbox"
              checked={analytics}
              onChange={(e) => setAnalytics(e.target.checked)}
              className="w-4 h-4 accent-primary cursor-pointer"
            />
            {t('cookieBanner.analyticsLabel')}
          </label>
        </div>

        <div className="flex gap-2 md:gap-3 flex-shrink-0 w-full md:w-auto">
          <button
            onClick={() => save(false)}
            className="flex-1 md:flex-initial border border-white/20 text-gray-300 hover:border-white/40 hover:text-white px-3 sm:px-5 py-2 rounded-lg text-xs md:text-sm transition-colors"
          >
            {t('cookieBanner.onlyNecessary')}
          </button>
          <button
            onClick={() => save(analytics)}
            className="flex-1 md:flex-initial bg-gradient-to-r from-primary to-purple-600 hover:from-primary-dark hover:to-purple-700 text-white font-semibold px-4 sm:px-5 py-2 rounded-lg text-xs md:text-sm transition-all"
          >
            {t('cookieBanner.accept')}
          </button>
        </div>
      </div>
    </div>
  )
}
